module.exports = __webpack_public_path__ + "static/media/logo-header.fdc2f759.png";